import ConfirmModal from '@components/modal/ConfirmModal';
import usePrevious from 'lib/src/hooks/usePrevious';
import { useEffect } from 'react';
import { AdminUser } from 'src/types/shared/AdminUser';
import useDowngradeSuperAdmin from '@pages/superAdminUsers/superAdminUsers/hooks/useDowngradeSuperAdmin';

const DowngradeAdminModal: React.FC<DeleteAdminProps> = ({ user, closeModal }) => {
    const { downgradeUser, isPosting, error, downgradeSuccess } = useDowngradeSuperAdmin(user.id);
    const prevSuccess = usePrevious(downgradeSuccess);

    useEffect(() => {
        if (!prevSuccess && downgradeSuccess) closeModal();
    }, [downgradeSuccess, prevSuccess, closeModal]);

    return (
        <ConfirmModal
            title="Downgrade admin"
            description={`Are you sure you want to downgrade '${user.firstName} ${user.lastName}' to Admin?`}
            closeModal={closeModal}
            handleSubmit={downgradeUser}
            isPosting={isPosting}
            error={error}
        />
    );
};

interface DeleteAdminProps {
    user: AdminUser;
    closeModal: () => void;
}

export default DowngradeAdminModal;
